module.exports = __webpack_public_path__ + "static/og-b4c953e24dc5171d42c83a6f0ac6fd91.png";